import React, { useState } from "react";

import WebHeader from "../components/WebHeader";
import WebFooter from "../components/WebFooter";
import NotFound from "../components/NotFound";
import PopUp from "../components/PopUp";


export default function PageNotFound() {
    const [popUpState, setPopUpState] = useState({
        isOpen: false,
        popUpType: "",
    });

    return (
        <div className="not-found-setting">
            {/* Pop Up */}
            <div className={popUpState.isOpen ? "popup-fixed-box" : "popup-notshow"}>
                <PopUp popUpState={popUpState} setPopUpState={setPopUpState} />
            </div>

            <div className="" >
                <div className="web-fixed-box">
                    <WebHeader popUpState={popUpState} setPopUpState={setPopUpState} />
                </div>

                <div className="not-found">
                    <NotFound />
                </div>

                <div className="web-fixed-box-footer">
                    <div className="web-row web-footer-outer-box">
                        <footer className="web-footer">
                            <WebFooter />
                        </footer>
                    </div>
                </div>

            </div>
        </div>
    );
}